export { default } from '../ExpandedHybridVdpPage.js';
